import { useState, useEffect } from 'react'
import Reveal from 'reveal.js'

import classNames from 'classnames'
import styles from 'styles/CharacterAccessoriesScreen.module.css'
import { characterAccessories } from '../assets/images/CharacterAccessoriesScreen'

import { sendSocketMessage } from 'config/socket/socketUtil'


type CharacterAccessoriesScreenPropsType = {
  heading: string;
  selectedAvatar: string;
  firebaseRef: any;
  socketInstance: any;
  remoteSelectedAccessories: string[];
}

type OptionsType = {
  avatar: string;
  accessory: string;
  imgSrc: string;
}

type selectedImages = {
  avatar: string;
  accessory: string;
  imgSrc: string;
}

function CharacterAccessoriesScreen({ heading, selectedAvatar, firebaseRef, socketInstance, remoteSelectedAccessories }: CharacterAccessoriesScreenPropsType) {

  const [accessories, setAccessories ] = useState<OptionsType[]>();

  const [ selectedAccessories, setSelectedAccessories ] = useState<string[]>([...remoteSelectedAccessories]);

  useEffect(() => {
    setSelectedAccessories([...remoteSelectedAccessories])
  }, [remoteSelectedAccessories])

  useEffect(() => {
    setSelectedAccessories([]);
    setAccessories(characterAccessories.filter(accessory=>accessory.avatar === selectedAvatar));
  }, [selectedAvatar])

  useEffect(() => {
    const callbackFunction = (state: any) => {
      if(state.selectedAccessory) {
        setSelectedAccessories(state.selectedAccessory);
      }
    }
    socketInstance.onMessage('characterAccessoriesScreen', callbackFunction)
  },[])

  const updateAccessory = (accessory: string) => {
    let imagesArray = [...selectedAccessories];
    if(selectedAccessories.includes(accessory)){
      imagesArray = selectedAccessories.filter(acc=> acc != accessory);
    }
    else if(selectedAccessories.length < 2){
      imagesArray.push(accessory);
    }
    setSelectedAccessories(imagesArray);
    firebaseRef.update({ selectedAccessories: imagesArray });
    sendSocketMessage({ state: { selectedAccessory: imagesArray }, action: 'characterAccessoriesScreen'})
  }
  const onClickSelect = () => {
    firebaseRef.update({ selectedAccessories });
    Reveal.next();
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        {heading}
      </div>
      <div className={styles.imagesWrapper}>
            {accessories?.map((accessory)=>{
              return (
                <img
                  key={accessory.accessory}
                  src={accessory.imgSrc}
                  alt={accessory.accessory}
                  className={classNames(styles.images,{[styles.selectedAccessory] : selectedAccessories.includes(accessory.accessory)})}
                  onClick={() => updateAccessory(accessory.accessory)}
                />
              )
    
            })
          }
      </div>
      <div className={selectedAccessories.length === 2 ? styles.button : styles.disabledButton} onClick={onClickSelect}>
        SELECT
      </div>
    </div>
  )
}

export default CharacterAccessoriesScreen